import { useAppBuilderContext } from 'app/app/editor/context';
import { MouseEvent } from 'react';
import { alpha, Box, Stack } from '@mui/material';
import styles from 'app/app/editor/index.styles';
import IconMi from 'components/common/icon/IconMi';
import NodeCssElements from 'app/app/editor/tabs/elements/layout/NodeCssElements';
import { useBlendColors } from 'hooks/useDesign';
import { IComponentNode } from 'app/app/editor/index.functions';
import NodeNameLine from 'app/app/editor/tabs/elements/layout/NodeNameLine';

export default function LayoutNode({
    node,
    componentUid,
    handleOpenContextMenu,
    isOpen,
    toggleOpen,
}: {
    node: IComponentNode;
    componentUid: string | null;
    handleOpenContextMenu: (event: MouseEvent, nodeUid: string) => void;
    isOpen: boolean;
    toggleOpen: () => void;
}) {
    const ctx = useAppBuilderContext();
    const [page, componentQuerySelector] = [ctx.page, ctx.componentQuerySelector];

    const isComponent = null !== node.params?.uid && page?.components?.[node.params?.uid];

    return (
        <Box sx={{ marginLeft: '10px', whiteSpace: 'nowrap' }}>
            <Stack
                direction={'row'}
                onContextMenu={(event) => handleOpenContextMenu(event, node.params?.uid)}
                sx={componentUid == node.params?.uid && null == componentQuerySelector ? styles.highlighted : {}}
            >
                <Box
                    sx={{
                        width: '16px',
                        height: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        color: (theme) => useBlendColors(alpha(theme.palette.text.primary, 0.64)),
                    }}
                >
                    {!isComponent && (
                        <Box
                            sx={{
                                width: '14px',
                                height: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 1,
                                '&:hover': {
                                    cursor: 'pointer',
                                    backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.08),
                                },
                                '.hierarchyItem:not(.active) &:hover': {
                                    color: 'text.primary',
                                },
                            }}
                            onClick={toggleOpen}
                        >
                            <IconMi
                                icon={isOpen ? 'nav-arrows-expand' : 'nav-arrows-collapse'}
                                sx={{ fontSize: '10px' }}
                            />
                        </Box>
                    )}
                </Box>
                <NodeNameLine node={node} />
            </Stack>
            {isComponent && isOpen && (
                <NodeCssElements node={node} componentUid={componentUid} uid={node.params?.uid} />
            )}
        </Box>
    );
}
